import * as Yup from 'yup';

export const SendToSAPValidationSchema = () =>
	Yup.object().shape({
		postingDate: Yup.date().nullable().required('Posting date is required.'),
	});
